import { Locales } from '@axo/config/@types/Locales.types';
import { ConfigService } from '@axo/config/ConfigService';
import { useTranslation } from '@axo/shared/i18n';
import { getTermsVersion } from '@axo/shared/util/string';
import { useEffect, useMemo, useRef, useState } from 'react';
import { TermsAndConditions } from '../@types/Terms.types';

export const useTerms = () => {
  const { brand } = ConfigService.get('global');

  const { i18n } = useTranslation();
  const locale = i18n.language;

  const termsLang = useRef('');
  const [terms, setTerms] = useState<TermsAndConditions[]>();

  useEffect(() => {
    let ignore = false;

    if (ignore || termsLang.current === locale) return;
    termsLang.current = locale;

    const getTerms = async () => {
      const isProduction = ConfigService.get('env').env === 'production';
      const { domain } = ConfigService.get('site');
      const subdomain = isProduction ? 'one.axogroup.com' : 'one.axo-test.io';

      const { defaultLocale } = ConfigService.get('global').i18n;

      const url = new URL(
        'api/cms/terms-and-conditions',
        `https://${domain}.${subdomain}`
      );

      if (locale !== defaultLocale.split('-').at(-1)?.toLowerCase()) {
        const _locale =
          Locales.find((l) => l.split('-').at(-1)?.toLowerCase() === locale) ||
          Locales[0];
        url.searchParams.append('locale', _locale);
      }

      const request = await fetch(url);
      const terms = await request.json();

      setTerms(terms);
    };

    getTerms();

    return () => {
      ignore = true;
    };
  }, [locale]);

  const version = useMemo(
    () =>
      terms?.reduce((acc, curr) => {
        return acc + getTermsVersion(curr, brand);
      }, '') ?? '',
    [terms, brand]
  );

  return { loading: !!terms, data: terms as TermsAndConditions[], version };
};
